module.exports = __webpack_public_path__ + "e7b0979b143585d29452553f32615d72.svg";